import { memo, useEffect, useMemo, useState } from 'react';
import { Card } from 'Card';
import { useTranslation } from 'react-i18next';
import { type useSessionTimer } from '../../hooks/useSessionTimer';
import './locales/TutorBotVoiceAgent/SessionWillEndSoonMessage-en.json';
import { type SessionWillEndSoonMessageKey } from './SessionWillEndSoonMessage.types';
import { getMessages } from './getMessages';

function SessionWillEndSoonMessageComponent({
    sessionTimer,
    messageKey = 'yourSessionWillEnd',
}: {
    sessionTimer: ReturnType<typeof useSessionTimer>;
    className?: string;
    messageKey?: SessionWillEndSoonMessageKey;
}) {
    const [secondsRemaining, setSecondsRemaining] = useState<number | null>(null);
    const { t } = useTranslation('back_royal', { keyPrefix: 'TutorBotVoiceAgent.SessionWillEndSoonMessage' });

    const message = useMemo(() => getMessages(t)[messageKey], [messageKey, t]);

    useEffect(() => {
        const callback = ({ secondsRemaining: newSecondsRemaining }: { secondsRemaining: number }) => {
            setSecondsRemaining(newSecondsRemaining);
        };

        sessionTimer.on('sessionWillEndSoon', callback);
        return () => {
            sessionTimer.off('sessionWillEndSoon', callback);
        };
    }, [sessionTimer]);

    if (secondsRemaining === null) return null;

    const minutes = Math.floor(secondsRemaining / 60);
    const seconds = Math.floor(secondsRemaining % 60);
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    return (
        <Card width={342} className="mx-auto animate-fade-in text-base">
            {message}
            <div className="text-center font-['Courier_New'] text-lg font-bold">{`${minutes}:${formattedSeconds}`}</div>
        </Card>
    );
}

export const SessionWillEndSoonMessage = memo(
    SessionWillEndSoonMessageComponent,
) as typeof SessionWillEndSoonMessageComponent;
